<template>
    <el-select :disabled="disabled" :clearable="true" v-model="contactSelected" @change="v=> $emit('selected', v)" :placeholder="selectPlaceholde" value-key="id">
      <el-option
        v-for="c in contacts"
        :key="c.id"
        :label="getName(c)"
        :value="c">
      </el-option>
    </el-select>
</template>
<script>
import ContactUtils from '@/utils/contact-utils.js'
export default {
	name: 'Contact-picker',
  props: {
    contacts : {type : Array, required:true},
    placeholder : {type : String},
    value : {type : Number},
    disabled : {type : Boolean, default : false}
	},
  data() {
    return {
      contactSelected : null,
    };
  },
  methods : {
    getName(contact){
      return ContactUtils.getName(contact);
    },
    selectContactBy(contactId){
        this.contactSelected = _.find(this.contacts, c=>{return c.id==contactId});
    }
  },
	computed : {
    getRules(){
      if(this.required==null || !this.required)return null;
      else{
        let rules = {
          contactSelected : [
    	  		 	{ required: true, message: this.requiredMessage, trigger: 'blur' }
    	  		],
        }
        return rules;
      }
    },
    selectPlaceholde(){
      if(this.placeholder==null)return '';
      return this.placeholder;
    }
	},
  watch: {
    value: function (val) {
      this.selectContactBy(val);
    }
  },
  mounted(){
    if(this.value!=null){
      this.selectContactBy(this.value);
    }else if(this.contacts!=null && this.contacts.length==1){
      this.selectContactBy(this.contacts[0].id);
      this.$emit('selected',this.contactSelected);
    }
  }

}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>


</style>
